import { useNavigate } from "react-router-dom";
import { LOGO_URL, SUPPORT_EMAIL } from "../../constants/brand";
import { TrustPortalWatermark } from "./TrustPortalWatermark";
import { useAuth } from "../../context/AuthContext";
import { SignOut } from "@phosphor-icons/react";

export function TrustPortalLayout({ children }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/trust-portal/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-igc-bg relative" data-testid="trust-portal-layout">
      <TrustPortalWatermark />
      <div className="relative z-[1] flex flex-col min-h-screen">
        <header className="flex items-center justify-between px-8 py-4 border-b border-igc-gold/10">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Iron Gate Consulting" className="w-9 h-9 object-contain" />
            <span className="font-serif text-lg text-igc-cream tracking-tight">IGC Trust Portal</span>
          </div>
          <button data-testid="trust-portal-logout-button" onClick={handleLogout} title="Signs you out of the Trust Portal." className="flex items-center gap-1.5 text-igc-muted hover:text-igc-goldText text-sm transition-colors">
            <SignOut size={16} weight="bold" /> Log Out
          </button>
        </header>
        <main className="flex-1 p-8 max-w-4xl w-full mx-auto">{children}</main>
        <footer className="text-center text-xs text-igc-muted py-6">Need help? {SUPPORT_EMAIL}</footer>
      </div>
    </div>
  );
}
